varying vec3 vWorldPosition;
uniform sampler2D map;
uniform vec3 color;
uniform vec2 repeat;
uniform float depthOffset;
uniform float alpha;
uniform bool isHovered;
varying vec2 vUv;

void main() {
    // Calculate depth based on distance from the camera
    float depth = distance(cameraPosition, vWorldPosition) + depthOffset;

    if(isHovered) {
        gl_FragColor = vec4(1.0, 1.0, 1.0, 0.8);
    } else {
        gl_FragColor = vec4(1.0, 1.0, 1.0, depth); //vec4(texture2D(map, vUv * repeat).rgb * color, depth);
    }
}
